import { useEffect, useMemo, useState } from "react";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import moment from "moment";
import "./CustomDateRange.css";

const CustomDateRange = ({ startDate, endDate, onChange }) => {
  const [dateLabel, setDateLabel] = useState(
    `${startDate} to ${endDate}`
  );

  useEffect(() => {
    setDateLabel(`${startDate} to ${endDate}`);
  }, [startDate, endDate]);

  const handleApply = (_, picker) => {
    const start = picker.startDate.format("YYYY-MM-DD");
    const end = picker.endDate.format("YYYY-MM-DD");

    setDateLabel(`${start} to ${end}`);

    onChange?.({
      startDate: start,
      endDate: end,
    });
  };

  const pickerSettings = useMemo(
    () => ({
      autoUpdateInput: false,
      alwaysShowCalendars: false,
      showCustomRangeLabel: true,
      opens: "left",

      startDate: moment(startDate),
      endDate: moment(endDate),

      locale: {
        format: "YYYY-MM-DD",
      },

      ranges: {
        Today: [moment(), moment()],

        Yesterday: [
          moment().subtract(1, "day"),
          moment().subtract(1, "day"),
        ],

        "Last 7 Days": [
          moment().subtract(6, "days"),
          moment(),
        ],

        "Last 30 Days": [
          moment().subtract(29, "days"),
          moment(),
        ],

        "This Month": [
          moment().startOf("month"),
          moment().endOf("month"),
        ],

        "Last Month": [
          moment().subtract(1, "month").startOf("month"),
          moment().subtract(1, "month").endOf("month"),
        ],

        "LIFE TIME": [
          moment("2020-01-01"),
          moment(),
        ],
      },
    }),
    [startDate, endDate]
  );

  return (
    <DateRangePicker
      key={`${startDate}-${endDate}`}
      initialSettings={pickerSettings}
      onApply={handleApply}
    >
      <button
        type="button"
        className="btn btn-light border text-primary"
        style={{ minWidth: "220px" }}
      >
        📅 {dateLabel}
      </button>
    </DateRangePicker>
  );
};

export default CustomDateRange;